import { DropRecord } from "@pro/common/contracts/atomicdropsx/ad_types";
import { EosApi } from "@pro/common/eos";

export class ADContract
{
	private readonly _api: EosApi;
	private readonly _account: string;

	constructor(api: EosApi, account: string)
	{
		this._account = account;
		this._api = api;
	}

	findDrop(key: string | number): Promise<DropRecord | undefined>
	{
		return this._api.findRecord(key, {
			code: this._account,
			scope: this._account,
			table: "drops",
			key_type: "i64",
		});
	}

	getAllDrops(): Promise<DropRecord[]>
	{
		return this._api.getFullTable({
			code: this._account,
			scope: this._account,
			table: "drops",
			key_type: "i64",
		});
	}
}